import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import { TariffLookups } from './model';
import { OrgHeaderView } from 'portcall/orgprofile/orgheaderview';
import { OrderableLookupsView } from 'portcall/orderablelookups/view';

export const TariffLookupsView = SuperCritical(({ model: m } : { model : TariffLookups }) =>
    <div className="tarifflookups pc-page-fixedwidth">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href={'#!orgprofile?id=' + m.Model.Id()}>&lt;&lt; Back to Organization</a>
        </div>
        <OrgHeaderView organization={m.Model} />
        <div className="page-body pc-card">
            <CargoActivitiesView model={m} />
            <TradeRoutesView model={m} />
            <CargoCategoriesView model={m} />
        </div>
    </div>
);

const CargoActivitiesView = SuperCritical(({ model: m } : { model : TariffLookups }) => {
    return (
        <div className="cargoactivities">
            <h2 className="pc-card-title lookup-section-title">Activities</h2>
            <div className="lookup-description pc-text-smalllabel">
                List the cargo activities available at your berths. These options appear in the In Port Ops tab
                of the Berth Assignment details.
            </div>
            <OrderableLookupsView
                model={m.CargoActivityLookups}
                columns={[{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: t => t.Name
                }]}
                addBtnText="+Add Activity"
            />
        </div>
    );
});

const TradeRoutesView = SuperCritical(({ model: m } : { model : TariffLookups }) => {
    return (
        <div className="traderoutes">
            <h2 className="pc-card-title lookup-section-title">Trade Routes</h2>
            <div className="lookup-description pc-text-smalllabel">
                List where your berths' cargo comes from and goes to. These routes appear in the In Port Ops tab
                of the Berth Assignment details. Leave empty to remove the Trade Routes field from the In Port
                Ops tab.
            </div>
            <OrderableLookupsView
                model={m.TradeRouteLookups}
                columns={[{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: t => t.Name
                }]}
                addBtnText="+Add New Trade Route"
            />
        </div>
    );
});

const CargoCategoriesView = SuperCritical(({ model: m } : { model : TariffLookups }) => {
    return (
        <div className="cargocategories">
            <h2 className="pc-card-title lookup-section-title">Cargo Categories</h2>
            <div className="lookup-description pc-text-smalllabel">
                List the categories of cargo at your berths. Each category has its own unit of measure. These
                categories appear in the In Port Ops tab of the Berth Assignment details.
            </div>
            <OrderableLookupsView
                model={m.CargoCategoryLookups}
                columns={[{
                    type: 'textInput',
                    title: 'Name',
                    className: 'name',
                    validationKey: 'Name',
                    itemProp: c => c.Name
                }, {
                    type: 'select',
                    title: 'Unit of Measure',
                    className: 'uom',
                    validationKey: 'UOM',
                    itemProp: c => c.UOM,
                    options: () => m.UOMOptions
                }]}
                addBtnText="+Add Cargo Type"
            />
        </div>
    );
});



// WEBPACK FOOTER //
// ./apps/portcall/tarifflookups/view.tsx